import { Fragment, useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import { bankIdMessageCodeEnumTranslations } from "./helper";

const steps = {
  init: "init",
  pending: "pending",
  error: "error",
};

const BankId = () => {
  const [step, setStep] = useState(steps.init);
  const [initResult, setInitResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  if (step === steps.init)
    return (
      <div style={{ textAlign: "center" }}>
        <Button
          fullWidth={true}
          variant={"outlined"}
          onClick={() => initBankId()}
        >
          Login
        </Button>
      </div>
    );

  if (step === steps.pending)
    return (
      <div style={{ textAlign: "center" }}>
        <BankIdPending {...{ ...initResult, setErrorMessage, setStep }} />
      </div>
    );

  if (step === steps.error)
    return (
      <div style={{ textAlign: "center" }}>
        <h2>Something went wrong! ({errorMessage})</h2>
      </div>
    );

  return <Fragment />;

  async function initBankId() {
    const result = await fetch("/api/admin/page/login/bankid-init-login", {
      method: "POST",
      body: JSON.stringify({ ClientId: reloansysConfig.appVersion }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    const response = await result.json();
    setInitResult(response);
    setStep(steps.pending);
  }
};

const BankIdPending = ({
  setStep,
  setErrorMessage,
  OrderRef,
  AutoStartToken,
}) => {
  const [statusUpdate, setStatusUpdate] = useState(null);
  const [qrCode, setQrCode] = useState("");

  useEffect(() => {
    pollForChanges();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const codeTranslation =
    bankIdMessageCodeEnumTranslations[statusUpdate?.MessageCode];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "center",
      }}
    >
      <h4>{codeTranslation ?? statusUpdate?.MessageCode}</h4>
      <img style={{ width: "15rem" }} src={qrCode} alt={"bankId-qr-code"} />
      <div style={{ height: 0, overflow: "hidden" }}>
        <iframe
          src={`bankid:///?autostarttoken=${AutoStartToken}&redirect=null`}
        />
      </div>
    </div>
  );

  async function pollForChanges() {
    const result = await fetch("/api/admin/page/login/bankid-update-status", {
      method: "POST",
      body: JSON.stringify({ OrderRef: OrderRef }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin", // Required for correlation token cookie
    });
    const response = await result.json();

    if (result.status === 299 || result.status >= 400) {
      setErrorMessage(response.Message);
      setStep(steps.error);
      return Promise.reject();
    }

    setStatusUpdate(response);

    if (response.Status === "pending")
      setTimeout(() => {
        pollForChanges();
        pollQrCode();
      }, 1000);
    else if (response.Status === "complete") {
      const result = await fetch(
        "/api/admin/page/login/bankid-complete-login",
        {
          method: "POST",
          body: JSON.stringify({ OrderRef }),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "same-origin", // Required for correlation token cookie
        },
      );
      const response = await result.json();
      const expire_date = new Date();
      expire_date.setSeconds(
        expire_date.getSeconds() + response.ExpiresInSeconds,
      );

      if (result.status === 299 || result.status >= 400) {
        setErrorMessage(response.Message);
        setStep(steps.error);
        return Promise.reject();
      }

      const token = {
        expires_in: expire_date,
        access_token: response.AccessToken,
        refresh_token: response.RefreshToken,
        token_type: "bearer",
      };

      localStorage.setItem("admin.usr", JSON.stringify(token));
      window.location.reload();
    } else {
      setErrorMessage(response.MessageCode);
      setStep(steps.error);
      return Promise.reject();
    }
  }

  async function pollQrCode() {
    const result = await fetch("/api/admin/page/login/bankid-generate-qr", {
      method: "POST",
      body: JSON.stringify({ OrderRef }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin", // Required for correlation token cookie
    });
    const response = await result.json();

    if (result.status !== 299 && result.status < 400)
      setQrCode(response.QrCode);
  }
};

export default BankId;
